<template>
  <video autoplay playsinline muted loop preload :poster="poster" ref="video">
    <source :src="source" />
  </video>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    source: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default() {
        return null;
      }
    }
  },
  mounted() {
    const ref = this.$refs.video;
    const m3u8 = /\.(m3u8)\?/i;
    const src = this.source;

    if (window.Hls && m3u8.test(src) && window.Hls.isSupported()) {
      const hls = new window.Hls();
      hls.loadSource(src);
      hls.attachMedia(ref);
      hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
        ref.play();
      });
      // When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
    } else if (
      m3u8.test(src) &&
      ref.canPlayType("application/vnd.apple.mpegurl")
    ) {
      ref.src = src;
      ref.addEventListener("loadedmetadata", () => {
        ref.play();
      });
      // If the source is something other than .m3u8, just play the source that was supplied
    } else {
      ref.play();
    }
  }
};
</script>

<style scoped lang="scss">
video {
  width: 100%;
  //height: 100%;
}
</style>
